export const formatAmount = (value) => {
  if (value) {
    const formattedValue = (value.toString()).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    return formattedValue ? `$${formattedValue}` : formattedValue;
  }
  return '';
};

export const formatDate = (value) => {
  if (value === undefined || value === null) return '';
  if (value.length >= 5) {
    return [value.slice(0, 2), '-', value.slice(2, 4), '-', value.slice(4, value.length)].join('');
  } else if (value.length >= 3) {
    return [value.slice(0, 2), '-', value.slice(2, value.length)].join('');
  } else {
    return value;
  }
};

export const toNumber = input => (input.toString()).replace(/[^\d]/g, '');

export const toDate = (value) => {
  if (value) {
    return toNumber(value).slice(0, 8);
  }
  return value;
};

export const toAlphabets = input => input.replace(/[^a-zA-Z\\' -]/g, '');

export const toStars = input => input.replace(/./g, '*');

export const formatWithHypen = (value, positions) => {
  let formattedValue = '';
  for(let index=0; index < value.length; index++){
    if(positions.includes(index)){
      formattedValue = formattedValue.concat('-');
    }
    formattedValue = formattedValue.concat(value[index]);
  }
  return formattedValue;
};

export const phoneNumberFormatter = input => {
  if (input === undefined || input === null || input === '') return '';
  return formatWithHypen(input, [3, 6]);
};

export const ssnFormatter = (input, maskAll = false) => {
  if (input === undefined || input === null || input === '') return '';
  input = input.substring(0, 9);
  let masked = maskAll ? toStars(input) : toStars(input.slice(0, input.length - 1)) + input.slice(-1);
  return formatWithHypen(masked, [3, 5]);
};

export const ssnLast4Formatter = (input) => {
  if (input === undefined || input === null || input === '') return '';
  input = input.substring(0, 9);
  let masked = toStars(input.slice(0, 5)) + input.slice(5);
  return formatWithHypen(masked, [3, 5]);
};

export const parseQueryString = (string) => {
  return string.slice(1).split("&")
    .map((queryParam) => {
      let kvp = queryParam.split("=");
      return { key: kvp[0], value: kvp[1] };
    })
    .reduce((query, kvp) => {
      query[kvp.key] = kvp.value;
      return query;
    }, {});
};
